module.exports = __webpack_public_path__ + "img/red-bg.759e4dce.png";